(() => {
  // First tab from the URL hash: #product, #compare (#compare-your-shade), #skin (#on-my-skin-tone / #know-your-shade).
  function hashView() {
    let h = (location.hash || "").slice(1);
    try {
      h = decodeURIComponent(h);
    } catch {
    }
    h = h.toLowerCase().replace(/[^a-z]/g, "");
    if (h === "product") return "product";
    if (h === "compare" || h === "compareyourshade") return "compare";
    if (h === "skin" || h === "onmyskintone" || h === "knowyourshade" || h === "skintone") return "skin";
    return "";
  }
  // src/ui.js
  function mountUI(root, data, cfg, services) {
    "use strict";
    const life = new AbortController();
    const qs = (s) => root.querySelector(s), qa = (s) => [...root.querySelectorAll(s)];
    let pendingFrame = 0;
    let current = data[0], tone = "light", ticking = false, view = "product", galleryIndex = 0, compare = [data[0].key, (data[1] || data[0]).key];
    const reduce = matchMedia("(prefers-reduced-motion:reduce)").matches;
    // Story animation runs only when the section shows it ("Show story animation"); reduced motion keeps the chapters but drops the movement.
    const storyOn = cfg.storyMotion !== false && !!qs("#kq6-story") && !qs("#kq6-story").hidden;
    const money2 = (c) => new Intl.NumberFormat("en-IN", { style: "currency", currency: current.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(c / 100);
    const starts = [0, 303, 449, 600], heights = [303, 146, 151, 161];
    function stack() {
      qs("#kq6-toggle-stack").hidden = current.pieces.length !== 4;
      qs("#kq6-interactive-quad").classList.toggle("no-pieces", current.pieces.length !== 4);
      // story: the old Quad story rig (kq6-story); absent when the page uses the exploded-tower story (kiro-quad-story).
      const hero = qs("#kq6-hero-stack"), story = qs("#kq6-story-rig");
      hero.replaceChildren();
      story?.replaceChildren();
      (current.pieces.length === 4 ? current.shades : []).forEach((shade, i) => {
        const row = document.createElement("div");
        row.className = "open-row";
        const image = document.createElement("img");
        image.src = current.pieces[i] || current.hero;
        image.alt = shade + " section";
        const label = document.createElement("span"), small = document.createElement("small");
        small.textContent = current.labels[i] || "";
        label.append(small, document.createTextNode(shade));
        row.append(image, label);
        hero.append(row);
        const p = document.createElement("div");
        p.className = "story-piece";
        p.style.top = starts[i] / 761 * 100 + "%";
        p.style.height = heights[i] / 761 * 100 + "%";
        const photo = document.createElement("img");
        photo.src = current.pieces[i] || current.hero;
        photo.alt = "";
        p.append(photo);
        story?.append(p);
      });
      if (!current.pieces.length) {
        const img = document.createElement("img");
        img.src = current.hero;
        img.alt = current.name;
        img.className = "whole-pack";
        story?.append(img);
      }
      hero.setAttribute("aria-label", current.name + " opened into its four shades");
    }
    function draw() {
      ticking = false;
      if (!storyOn) return;
      const story = qs("#kq6-story"), pin = qs(".story-pin");
      const top = parseFloat(getComputedStyle(pin).top) || 0;
      const p = Math.max(0, Math.min(1, (top - story.getBoundingClientRect().top) / Math.max(1, story.offsetHeight - pin.offsetHeight)));
      const pos = p * 3, stage = Math.round(pos);
      const smooth = (v) => {
        v = Math.max(0, Math.min(1, v));
        return v * v * (3 - 2 * v);
      };
      const split = smooth((pos - 0.4) / 0.4) * (1 - smooth((pos - 1.65) / 0.45));
      const mobile = window.innerWidth <= 600;
      const rig = qs("#kq6-story-rig");
      if (!reduce) {
        rig.style.transform = "rotate(" + (-14 + split * 14 + p * 5) + "deg) scale(" + (1 - split * 0.13) + ")";
        qa(".story-piece").forEach((piece, i) => {
          piece.style.transform = "translate(" + (i % 2 ? 1 : -1) * split * (mobile ? 4 : 8) + "px," + (i - 1.5) * split * (mobile ? 16 : 35) + "px)";
        });
        const paint = qs(".texture-reveal");
        paint.style.clipPath = "inset(" + 100 * (1 - Math.min(1, p * 2.2 + 0.07)) + "% 0 0 0)";
        paint.style.opacity = String(0.12 + Math.sin(p * Math.PI) * 0.55);
        paint.style.transform = "translate(-50%,-50%) rotate(" + (-16 + p * 32) + "deg) scale(" + (0.9 + p * 0.2) + ")";
      }
      qa("[data-chapter]").forEach((el, i) => {
        const opacity = reduce ? +(i === stage) : Math.max(0, 1 - Math.abs(pos - i) * 1.8);
        el.style.opacity = String(opacity);
        el.style.transform = reduce ? "none" : "translateY(" + (i - pos) * 24 + "px)";
        el.style.pointerEvents = i === stage ? "auto" : "none";
        el.inert = i !== stage;
        el.setAttribute("aria-hidden", String(i !== stage));
      });
      qa("[data-step]").forEach((b) => b.setAttribute("aria-pressed", String(Number(b.dataset.step) === stage)));
      qs("#kq6-chapter-count").textContent = "0" + (stage + 1) + " / 04";
      qs(".progress i").style.transform = "scaleX(" + p + ")";
      story.dataset.progress = p.toFixed(4);
      story.dataset.stage = String(stage);
    }
    function schedule() {
      if (!ticking) {
        ticking = true;
        pendingFrame = requestAnimationFrame(draw);
      }
    }
    // Display name of a skin tone; the "dark" key (quad_detail skintone_images.dark) is shown as "Deep".
    const toneName = (t) => t === "dark" ? "deep" : t;
    function lipCards(q, grid) {
      grid.replaceChildren();
      q.shades.forEach((shade, i) => {
        const f = document.createElement("figure");
        f.className = "lip-card";
        const src = q.toneLips?.[tone]?.[i];
        if (src) {
          const img = document.createElement("img");
          img.src = src;
          img.width = 520;
          img.height = 520;
          img.alt = shade + " on " + toneName(tone) + " skin";
          f.append(img);
        } else {
          const missing = document.createElement("div");
          missing.className = "missing-photo";
          missing.textContent = "Original " + toneName(tone) + "-tone photo unavailable";
          f.append(missing);
        }
        const cap = document.createElement("figcaption");
        cap.textContent = shade;
        f.append(cap);
        grid.append(f);
      });
    }
    function quadButton(q, choose2) {
      const b = document.createElement("button");
      b.className = "quad-button";
      b.dataset.quad = q.key;
      b.setAttribute("aria-label", q.name);
      const c = document.createElement("span");
      c.className = "quad-colours";
      c.setAttribute("aria-hidden", "true");
      q.colours.forEach((col) => {
        const i = document.createElement("i");
        i.style.background = col;
        c.append(i);
      });
      // Button text without the word "Quad" ("Ultimate Quad" -> "Ultimate"); aria-label keeps the full name.
      b.append(c, document.createTextNode(q.name.replace(/\bquad\b/gi, "").replace(/\s+/g, " ").trim() || q.name));
      b.addEventListener("click", () => choose2(q.key));
      return b;
    }
    function renderSkin() {
      qa("[data-tone]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.tone === tone)));
      qs("#kq6-skin-caption").textContent = current.name + " \xB7 " + toneName(tone)[0].toUpperCase() + toneName(tone).slice(1) + " skin tone";
      lipCards(current, qs("#kq6-hero-lips"));
      renderCompare();
    }
    function renderCompare() {
      const grid = qs("#kq6-compare-grid");
      grid.replaceChildren();
      compare.forEach((key, side) => {
        const q = data.find((x) => x.key === key), card = document.createElement("article");
        card.className = "compare-card";
        card.setAttribute("aria-label", "Compare quad " + (side + 1));
        const heading = document.createElement("h3");
        heading.textContent = q.name;
        const label = document.createElement("small");
        label.className = "compare-label";
        label.textContent = "QUAD " + (side + 1) + " \xB7 " + toneName(tone).toUpperCase();
        const lips = document.createElement("div");
        lips.className = "quad-lips";
        lipCards(q, lips);
        const rail = document.createElement("div");
        rail.className = "compare-choices";
        rail.setAttribute("aria-label", "Choose quad " + (side + 1));
        data.forEach((item) => {
          const b = quadButton(item, (k) => {
            if (side === 0) choose(k);
            else {
              compare[side] = k;
              renderCompare();
            }
          });
          b.setAttribute("aria-pressed", String(item.key === key));
          rail.append(b);
        });
        const hint = document.createElement("div");
        hint.className = "rail-hint";
        hint.innerHTML = "<span>Swipe quads \u2192</span>";
        const next = document.createElement("button");
        next.type = "button";
        next.textContent = "\u203A";
        next.setAttribute("aria-label", "More options for quad " + (side + 1));
        next.addEventListener("click", () => rail.scrollBy({ left: 150, behavior: reduce ? "auto" : "smooth" }));
        const prev = document.createElement("button");
        prev.type = "button";
        prev.textContent = "\u2039";
        prev.setAttribute("aria-label", "Previous options for quad " + (side + 1));
        prev.addEventListener("click", () => rail.scrollBy({ left: -150, behavior: reduce ? "auto" : "smooth" }));
        hint.append(prev, next);
        const add = document.createElement("button");
        add.className = "primary compare-add";
        add.textContent = "Add to Bag \xB7 " + money2(q.price);
        add.setAttribute("aria-label", "Add " + q.name + " to bag");
        add.disabled = !q.available;
        add.dataset.unavailable = String(!q.available);
        add.addEventListener("click", () => addItem(q, 1));
        card.append(label, heading, lips, hint, rail, add);
        grid.append(card);
      });
    }
    function gallery() {
      qs("#kq6-interactive-quad").hidden = galleryIndex !== 0;
      qs("#kq6-gallery-zoom").hidden = galleryIndex === 0;
      if (galleryIndex) {
        const img = qs("#kq6-gallery-photo");
        img.src = current.gallery[galleryIndex - 1];
        img.alt = current.name + " \u2014 original Kiro product image " + galleryIndex;
      }
      const dots = qs("#kq6-gallery-dots");
      dots.replaceChildren();
      for (let n = 0; n <= current.gallery.length; n++) {
        const b = document.createElement("button");
        b.setAttribute("aria-label", n === 0 ? "Interactive open and close Quad" : "Product image " + n);
        b.setAttribute("aria-pressed", String(n === galleryIndex));
        b.addEventListener("click", () => {
          galleryIndex = n;
          gallery();
        });
        dots.append(b);
      }
    }
    function moveGallery(by) {
      galleryIndex = (galleryIndex + by + current.gallery.length + 1) % (current.gallery.length + 1);
      gallery();
    }
    function select(key) {
      const chosen = data.find((q) => q.key === key);
      if (!chosen) return;
      current = chosen;
      compare[0] = key;
      galleryIndex = 0;
      qa("[data-selected]").forEach((el) => el.textContent = current.name);
      // Shopify money_with_currency text (same as the V3 buy box); Intl format only as a fallback.
      qa("[data-price]").forEach((el) => el.textContent = current.priceText || money2(current.price));
      // V3 buy box rating: one decimal, star fill, hidden when there are no reviews.
      qa("[data-rating]").forEach((el) => el.textContent = current.rating != null ? Math.round(current.rating * 10) / 10 : "\u2014");
      qa("[data-reviews]").forEach((el) => el.textContent = current.reviewCount ?? "0");
      qa("[data-kp-stars]").forEach((el) => el.style.setProperty("--kp-fill", Math.min(100, (current.rating || 0) * 20) + "%"));
      qa("[data-kp-rating]").forEach((el) => el.hidden = !(current.reviewCount > 0));
      qa("#kq6-hero-quads [data-quad]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.quad === key)));
      qs("#kq6-hero-photo").src = current.hero;
      qs("#kq6-hero-photo").alt = current.name + " with its four original lipstick textures";
      if (current.macro && qs("#kq6-story-texture")) qs("#kq6-story-texture").src = current.macro;
      qa(".add").forEach((b) => b.disabled = !current.available);
      stack();
      renderSkin();
      gallery();
      draw();
      services.update(current);
      root.dataset.quad = key;
      root.querySelector("[data-quad-host]").dispatchEvent(new CustomEvent("kiro:pdp:shade-change", { bubbles: true }));
    }
    function setView(next) {
      view = next;
      qa("[data-view]").forEach((b) => {
        const yes = b.dataset.view === view;
        b.setAttribute("aria-selected", String(yes));
        b.tabIndex = yes ? 0 : -1;
        qs("#kq6-panel-" + b.dataset.view).hidden = !yes;
      });
      qs("#kq6-tone-controls").hidden = view === "product";
      qs("#kq6-quad-picker").hidden = view === "compare";
      qs(".hero-workspace").classList.toggle("comparing", view === "compare");
      root.dataset.view = view;
      draw();
    }
    function addItem(q, qty) {
      return services.add(q, qty);
    }
    function quantity() {
      const input = qs("#kq6-quantity");
      const n = Math.min(10, Math.max(1, Math.floor(Number(input.value) || 1)));
      input.value = n;
      return n;
    }
    data.forEach((q) => qs("#kq6-hero-quads").append(quadButton(q, choose)));
    async function choose(key) {
      const q = data.find((x) => x.key === key);
      if (!q) return;
      try {
        const fresh = await services.refresh(q);
        if (life.signal.aborted) return;
        Object.assign(q, fresh);
        select(key);
      } catch (error) {
        services.status(error.message);
      }
    }
    qa("[data-view]").forEach((b, i) => {
      b.addEventListener("click", () => setView(b.dataset.view));
      b.addEventListener("keydown", (e) => {
        const tabs = qa("[data-view]");
        let next;
        if (e.key === "ArrowRight") next = (i + 1) % 3;
        else if (e.key === "ArrowLeft") next = (i + 2) % 3;
        else if (e.key === "Home") next = 0;
        else if (e.key === "End") next = 2;
        else return;
        e.preventDefault();
        setView(tabs[next].dataset.view);
        tabs[next].focus();
      });
    });
    qa("[data-tone]").forEach((b) => b.addEventListener("click", () => {
      tone = b.dataset.tone;
      renderSkin();
    }));
    qs("#kq6-toggle-stack").addEventListener("click", () => {
      const button2 = qs("#kq6-toggle-stack"), closed = qs("#kq6-hero-stack").classList.toggle("is-closed");
      button2.setAttribute("aria-expanded", String(!closed));
      button2.textContent = closed ? "Open quad +" : "Close quad \u2212";
    });
    qs("#kq6-toggle-stack").textContent = "Close quad \u2212";
    qs("#kq6-gallery-prev").addEventListener("click", () => moveGallery(-1));
    qs("#kq6-gallery-next").addEventListener("click", () => moveGallery(1));
    let touchX = null, touchY = null;
    qs("#kq6-gallery-stage").addEventListener("touchstart", (e) => {
      touchX = e.changedTouches[0].clientX;
      touchY = e.changedTouches[0].clientY;
    }, { passive: true, signal: life.signal });
    qs("#kq6-gallery-stage").addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY;
      if (touchX !== null && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) moveGallery(dx < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true, signal: life.signal });
    qs("#kq6-gallery-zoom").addEventListener("click", () => {
      qs("#kq6-zoom-photo").src = qs("#kq6-gallery-photo").src;
      qs("#kq6-zoom-photo").alt = qs("#kq6-gallery-photo").alt;
      qs("#kq6-zoom").showModal();
    });
    qs("#kq6-close-zoom").addEventListener("click", () => qs("#kq6-zoom").close());
    qs("#kq6-qty-minus").addEventListener("click", () => {
      qs("#kq6-quantity").value = Math.max(1, quantity() - 1);
    });
    qs("#kq6-qty-plus").addEventListener("click", () => {
      qs("#kq6-quantity").value = Math.min(10, quantity() + 1);
    });
    qs("#kq6-quantity").addEventListener("change", quantity);
    qs("[data-purchase-form]").addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      addItem(current, quantity());
    }, { capture: true });
    qa(".sticky-buy .add, .quad-buy .add").forEach((b) => b.addEventListener("click", () => addItem(current, quantity())));
    qa("[data-step]").forEach((b) => b.addEventListener("click", () => {
      const section = qs("#kq6-story"), pin = qs(".story-pin");
      window.scrollTo({ top: scrollY + section.getBoundingClientRect().top - parseFloat(getComputedStyle(pin).top) + (section.offsetHeight - pin.offsetHeight) * Number(b.dataset.step) / 3, behavior: reduce ? "auto" : "smooth" });
    }));
    qs("#kq6-discover-quads")?.addEventListener("click", () => setView("skin"));
    ["#kq6-zoom"].forEach((s) => qs(s).addEventListener("click", (e) => {
      if (e.target === qs(s)) qs(s).close();
    }));
    // V3 offers: copy the offer code (same behaviour as kiro-v3-pdp.js copyCode).
    root.addEventListener("click", async (e) => {
      const b = e.target.closest("[data-kp-copy]");
      if (!b || !root.contains(b)) return;
      const code = b.dataset.kpCopy, live = qs("[data-kp-live]");
      try {
        await navigator.clipboard.writeText(code);
        b.classList.add("is-copied");
        clearTimeout(b._kpCopied);
        b._kpCopied = setTimeout(() => b.classList.remove("is-copied"), 2e3);
        if (live) live.textContent = `${code} copied. Apply at checkout.`;
      } catch {
        b.title = `Code: ${code}`;
        b.setAttribute("aria-label", `Code: ${code}`);
        if (live) live.textContent = `Use code ${code} at checkout.`;
      }
    }, { signal: life.signal });
    const purchase = qs(".quad-buy"), sticky = qs(".sticky-buy");
    function syncSticky() {
      const rect = purchase.getBoundingClientRect();
      sticky.hidden = rect.bottom > cfg.headerOffset;
      sticky.setAttribute("aria-hidden", String(sticky.hidden));
    }
    const buyObserver = new IntersectionObserver(syncSticky, { threshold: [0, 1] });
    buyObserver.observe(purchase);
    window.addEventListener("scroll", syncSticky, { passive: true, signal: life.signal });
    window.addEventListener("resize", syncSticky, { signal: life.signal });
    const resizeObserver = new ResizeObserver(syncSticky);
    resizeObserver.observe(root);
    syncSticky();
    if (storyOn) {
      window.addEventListener("scroll", schedule, { passive: true, signal: life.signal });
      window.addEventListener("resize", schedule, { signal: life.signal });
      window.visualViewport?.addEventListener("resize", schedule, { signal: life.signal });
    }
    select(current.key);
    // First view: the tab named in the URL hash (e.g. /products/handle#on-my-skin-tone), else Product.
    setView(hashView() || "product");
    window.addEventListener("hashchange", () => {
      const next = hashView();
      if (next) setView(next);
    }, { signal: life.signal });
    root.dataset.ready = "true";
    return { getCurrent: () => current, selectHandle: (handle) => choose(handle), apply(q) {
      const target = data.find((x) => x.handle === q.handle);
      if (target) {
        Object.assign(target, q);
        select(target.key);
      }
    }, addProduct(q) {
      if (data.some((x) => x.key === q.key)) return;
      data.push(q);
      qs("#kq6-hero-quads").append(quadButton(q, choose));
      renderCompare();
    }, dispose() {
      life.abort();
      cancelAnimationFrame(pendingFrame);
      buyObserver.disconnect();
      resizeObserver.disconnect();
    } };
  }

  // src/shared-airy/cart-coordinator.js
  // One bag lock for the Quad and the V3 duo (kq6-v3-duo.js loads first and exposes the same coordinator).
  var cartCoordinator = window.KiroV3Duo && window.KiroV3Duo.cart || {
    busy: false,
    acquire() {
      if (this.busy) throw new Error("Your bag is being updated. Please wait.");
      this.busy = true;
      this.notify();
      let released = false;
      return () => {
        if (!released) {
          released = true;
          this.busy = false;
          this.notify();
        }
      };
    },
    notify() {
      if (typeof document !== "undefined") document.dispatchEvent(new CustomEvent("kiro:cart:busy", { detail: { busy: this.busy } }));
    }
  };

  // src/shared-airy/kiro-pdp-services.js
  var deepFreeze = (value) => {
    if (value && typeof value === "object" && !Object.isFrozen(value)) {
      Object.freeze(value);
      Object.values(value).forEach(deepFreeze);
    }
    return value;
  };
  var positiveID = (value) => Number.isSafeInteger(value) && value > 0;
  var money = (value) => Number.isSafeInteger(value) && value >= 0;
  function validateProduct(data, { handle, group, variant } = {}) {
    const valid = data?.schemaVersion === 1 && positiveID(data.id) && typeof data.handle === "string" && typeof data.group === "string" && typeof data.shade === "string" && typeof data.franchise === "string" && typeof data.url === "string" && data.url.startsWith("/") && !data.url.startsWith("//") && /^[A-Z]{3}$/.test(data.currency) && typeof data.priceText === "string" && positiveID(data.variant?.id) && money(data.variant.price) && money(data.variant.compareAt) && typeof data.variant.available === "boolean" && Array.isArray(data.variants) && data.variants.length > 0 && data.variants.every((v) => positiveID(v.id) && typeof v.title === "string" && typeof v.available === "boolean") && data.variants.some((v) => v.id === data.variant.id) && (handle == null || data.handle === handle) && (group == null || data.group === group) && (variant == null || data.variant.id === Number(variant));
    if (!valid) throw new Error("The product response did not match the requested product, franchise or variant.");
    for (const key of ["gallery", "faqs", "quotes"]) if (data[key] != null && !Array.isArray(data[key])) throw new Error(`Invalid ${key} data.`);
    for (const key of ["ingredients", "description", "directions", "weight", "origin", "expiry"]) if (data[key] != null && typeof data[key] !== "string") throw new Error(`Invalid ${key} text.`);
    if (data.gallery?.some((item) => !item || typeof item.url !== "string")) throw new Error("Invalid gallery entry.");
    if (data.faqs?.some((item) => !item || typeof (item.Q || item.question) !== "string" || typeof (item.A || item.answer) !== "string")) throw new Error("Invalid FAQ entry.");
    if (data.quotes?.some((item) => !item || typeof item.review_review_description !== "string")) throw new Error("Invalid quote entry.");
    for (const media of [data.mediaOverride, data.reviewedMedia]) if (media?.panels && (!Array.isArray(media.panels) || media.panels.some((item) => !item || typeof item.url !== "string"))) throw new Error("Invalid skin panel entry.");
    return deepFreeze(data);
  }
  var Routes = class {
    constructor(config, href) {
      this.config = config;
      this.location = new URL(href);
      this.preview = this.location.searchParams.get("view") === config.templateView;
    }
    path(handle) {
      return `${this.config.root.replace(/\/$/, "")}/products/${encodeURIComponent(handle)}`;
    }
    product(handle, variant, view) {
      const url = new URL(this.path(handle), this.location.origin);
      this.location.searchParams.forEach((value, key) => {
        if (!["view", "variant", "section_id", "sections"].includes(key)) url.searchParams.set(key, value);
      });
      if (variant) url.searchParams.set("variant", String(variant));
      if (view) url.searchParams.set("view", view);
      else if (this.preview) url.searchParams.set("view", this.config.templateView);
      return url;
    }
    local(value) {
      const url = new URL(value, this.location);
      if (url.origin !== this.location.origin) throw new Error("A storefront route must use the current origin.");
      return url;
    }
  };
  var ProductRepository = class {
    constructor({ routes, handles, group, parse, fetcher = (...args) => globalThis.fetch(...args), now = Date.now, ttl = 15e3, maxEntries = 100, timeout = 15e3 }) {
      Object.assign(this, { routes, group, parse, fetcher, now, ttl, maxEntries, timeout });
      this.handles = new Set(handles);
      this.cache = /* @__PURE__ */ new Map();
      this.pending = /* @__PURE__ */ new Map();
      this.controllers = /* @__PURE__ */ new Set();
      this.disposed = false;
    }
    key(handle, variant) {
      return `${handle}:${variant || ""}`;
    }
    clear() {
      this.cache.clear();
    }
    seed(data) {
      this.store(this.key(data.handle, data.variant.id), validateProduct(data, { group: this.group }));
    }
    store(key, data) {
      this.cache.delete(key);
      this.cache.set(key, { expires: this.now() + this.ttl, data });
      while (this.cache.size > this.maxEntries) this.cache.delete(this.cache.keys().next().value);
    }
    async get(handle, variant) {
      if (this.disposed) throw new Error("This PDP has been disconnected.");
      if (!this.handles.has(handle)) throw new Error("This shade does not belong to this franchise.");
      if (variant != null && !positiveID(Number(variant))) throw new Error("Invalid variant ID.");
      const key = this.key(handle, variant), cached = this.cache.get(key);
      if (cached?.expires > this.now()) return cached.data;
      this.cache.delete(key);
      if (this.pending.has(key)) return this.pending.get(key);
      const controller = new AbortController();
      this.controllers.add(controller);
      const timer = setTimeout(() => controller.abort(), this.timeout);
      const task = (async () => {
        const response = await this.fetcher(this.routes.product(handle, variant, this.routes.config.dataView), { credentials: "same-origin", signal: controller.signal, headers: { Accept: "text/html" }, cache: "no-store" });
        if (!response.ok) throw new Error("Shade details are temporarily unavailable.");
        const data = validateProduct(this.parse(await response.text()), { handle, group: this.group, variant });
        if (this.disposed) throw new Error("This PDP has been disconnected.");
        this.store(key, data);
        return data;
      })();
      this.pending.set(key, task);
      try {
        return await task;
      } finally {
        clearTimeout(timer);
        this.controllers.delete(controller);
        this.pending.delete(key);
      }
    }
    dispose() {
      this.disposed = true;
      this.controllers.forEach((c) => c.abort());
      this.controllers.clear();
      this.pending.clear();
      this.cache.clear();
    }
  };

  // src/data.js
  function object(value) {
    for (let i = 0; i < 2 && typeof value === "string"; i++) {
      try {
        value = JSON.parse(value);
      } catch {
        return {};
      }
    }
    return value && typeof value === "object" ? value : {};
  }
  function mediaURL(value) {
    if (typeof value !== "string") return "";
    try {
      const u = new URL(value, "https://kirobeauty.com");
      return ["http:", "https:"].includes(u.protocol) ? value : "";
    } catch {
      return "";
    }
  }
  function normalize(raw, reviewed = {}) {
    const pm = object(raw.pm), vm = object(raw.vm), pd = vm.product_detail || {}, gd = vm.general_detail || {}, pg = pm.general_detail || {};
    const group = pg.product_listing || raw.group;
    const mapped = object(raw.media), fallback = reviewed[raw.handle] || {};
    const m = mapped.group === group ? mapped : fallback;
    const shades = Array.isArray(m.shades) && m.shades.length === 4 ? m.shades.map(String) : ["Shade 1", "Shade 2", "Shade 3", "Shade 4"];
    const gallery = (Array.isArray(raw.gallery) && raw.gallery.length ? raw.gallery : raw.nativeGallery || []).filter((x) => mediaURL(x.url));
    const p = {
      ...raw,
      group,
      shade: gd.shade_name || pg.shade_name || raw.title,
      franchise: pg.product_name || gd.product_name || raw.title,
      gallery,
      description: pd.descriptionSEO?.description || pd.description || raw.description || "",
      ingredients: pd.ingredients_listSEO?.description || pd.ingredients_list || "",
      directions: pd.direction_of_useSEO?.description || pd.direction_of_use || "",
      weight: pg.weight_volume || "",
      origin: pg.country_of_origin || "",
      expiry: gd.expiry_date || ""
    };
    validateProduct(p);
    const rv = object(raw.reviews), hero = mediaURL(m.hero) || mediaURL(raw.featuredImage) || gallery[0]?.url || "";
    return {
      ...p,
      key: p.handle,
      name: p.shade,
      price: p.variant.price,
      available: p.variant.available,
      // Quad picker swatch: variantV2.variantV2.quad_detail.shades[].color_hex, one strip per shade; older sources only as a fallback.
      colours: (Array.isArray(raw.quadColours) && raw.quadColours.length ? raw.quadColours : Array.isArray(m.colours) && m.colours.length === 4 ? m.colours : Array(4).fill(gd.color_hex || pg.color_hex || "#8a4e3a")).map((c) => /^#[\da-f]{3,8}$/i.test(c) ? c : "#8a4e3a"),
      shades,
      hasShadeMapping: !!m.shades,
      hero,
      macro: mediaURL(m.macro),
      // quad_detail.shades[].small_text (label above each shade name in the open stack).
      labels: shades.map((_, i) => Array.isArray(m.labels) && typeof m.labels[i] === "string" ? m.labels[i] : ""),
      pieces: Array.isArray(m.pieces) && m.pieces.length === 4 && m.pieces.every(mediaURL) ? m.pieces : [],
      toneLips: Object.fromEntries(["dark", "medium", "light"].map((t) => [t, shades.map((_, i) => mediaURL(m.toneLips?.[t]?.[i]) || null)])),
      gallery: gallery.map((x) => x.url),
      galleryEntries: gallery,
      rating: typeof rv.rating === "number" ? rv.rating : null,
      reviewCount: typeof rv.total === "number" ? rv.total : null,
      formulaClaims: pd.caqSEO?.description || "",
      certificates: Array.isArray(raw.certificates) ? raw.certificates.filter((c) => c.group === group && mediaURL(c.url) && c.title) : []
    };
  }
  function canonical(q) {
    return { ...q, gallery: q.galleryEntries };
  }

  // Build Your Duo: the Airy Matte V3 duo (window.KiroV3Duo from kq6-v3-duo.js, the duo module of kiro-v3-pdp.js) is mounted in main.js.

  // src/main.js
  function rich(target, html) {
    if (!target) return;
    const doc = new DOMParser().parseFromString(String(html || ""), "text/html");
    doc.querySelectorAll("script,style,iframe,object,embed,form,input,button,link,meta").forEach((n) => n.remove());
    doc.querySelectorAll("*").forEach((n) => {
      for (const a of [...n.attributes]) if (!["href", "title", "class"].includes(a.name)) n.removeAttribute(a.name);
      if (n.hasAttribute("href") && !mediaURL(n.getAttribute("href"))) n.removeAttribute("href");
    });
    target.replaceChildren(...doc.body.childNodes);
  }
  var instances = /* @__PURE__ */ new Map();
  function mount(root) {
    if (instances.has(root)) return instances.get(root);
    const cfg = JSON.parse(root.querySelector("[data-config]").textContent), reviewed = JSON.parse(root.querySelector("[data-reviewed-media]").textContent);
    cfg.root = cfg.root.replace(/\/?$/, "/");
    const routes = new Routes(cfg, location.href);
    const initial = JSON.parse(root.querySelector("[data-products]").textContent).map((p) => normalize(p, reviewed)).filter((p) => p.group === cfg.group);
    if (!initial.length) throw new Error("No matching Quad product was found.");
    const registry = object(JSON.parse(root.querySelector("[data-listing]")?.textContent || "{}"));
    const entries = Array.isArray(registry) ? registry : [];
    const handles = [.../* @__PURE__ */ new Set([...initial.map((p) => p.handle), ...entries.map((p) => p.handle).filter((h) => typeof h === "string" && /^[a-z0-9-]+$/.test(h))])];
    const parse = (html) => canonical(normalize(JSON.parse(new DOMParser().parseFromString(html, "text/html").querySelector("[data-kp-response]").textContent), reviewed));
    const repository = new ProductRepository({ routes, handles, group: cfg.group, parse });
    const host = root.querySelector("[data-quad-host]"), life = new AbortController();
    const header = document.querySelector(".header-area");
    let headerObserver;
    if (header) {
      const measure = () => {
        const h = Math.ceil(header.getBoundingClientRect().height);
        cfg.headerOffset = h;
        root.style.setProperty("--kq-header", h + "px");
      };
      measure();
      headerObserver = new ResizeObserver(measure);
      headerObserver.observe(header);
    }
    // Space above the tabs: same rule as sections/kiro-product-pdp-v3.liquid. A fixed desktop header (100-135px) can cover the tabs,
    // so only the overlap (+12px) is added as top padding above 700px wide; phones keep the layout as it is.
    // Measured only at load and on resize (not on scroll), so a header that shrinks while scrolling never shifts the page.
    const tabsBar = root.querySelector(".kp-tabs");
    if (tabsBar) {
      const GAP = 12;
      const fitTop = () => {
        const bar = document.querySelector("header.header-area");
        root.style.paddingTop = "";
        if (!bar || window.innerWidth <= 700 || getComputedStyle(bar).position !== "fixed") return;
        const overlap = bar.getBoundingClientRect().bottom - (tabsBar.getBoundingClientRect().top + window.scrollY);
        if (overlap > -GAP) root.style.paddingTop = Math.ceil(overlap + GAP) + "px";
      };
      let fitTimer;
      window.addEventListener("resize", () => {
        clearTimeout(fitTimer);
        fitTimer = setTimeout(fitTop, 150);
      }, { passive: true, signal: life.signal });
      window.addEventListener("load", fitTop, { signal: life.signal });
      fitTop();
    }
    let ui, duo, seq = 0, variantSeq = 0, adding = false, uncertain = false;
    const qs = (s) => root.querySelector(s), status = (message) => {
      qs("[data-purchase-status]").textContent = message;
    };
    // V3 product data (kiro-pdp-v3-data view) for the selected Quad: the V3 duo needs its title, SKU, duo image and recommendations.
    const V3 = window.KiroV3Duo, v3Data = /* @__PURE__ */ new Map();
    let v3routes = null, v3repo = null;
    let v3FieldsFor = null;
    if (V3) {
      let seed = null;
      try {
        seed = V3.validate(JSON.parse(qs("[data-kq6-v3-data]").textContent));
      } catch (e) {
        console.warn("Kiro Quad: V3 product data unavailable.", e);
      }
      v3routes = new V3.Routes({ root: cfg.root, dataView: cfg.v3DataView, cartAdd: cfg.cartAdd, cartUrl: cfg.cartUrl }, location.href);
      v3repo = new V3.Repository({ routes: v3routes, handles, group: seed?.group || cfg.group, parse: (html) => {
        const node = new DOMParser().parseFromString(html, "text/html").querySelector("[data-kp-response]");
        if (!node) throw new Error("Product data is unavailable.");
        return JSON.parse(node.textContent);
      } });
      if (seed) {
        v3repo.seed(seed);
        v3Data.set(seed.handle, seed);
        v3FieldsFor = seed.handle;
      }
    }
    async function loadV3(handle, variant) {
      if (!v3repo) return;
      try {
        v3Data.set(handle, await v3repo.get(handle, variant));
      } catch {
      }
    }
    async function openCart() {
      // Same as the V3 PDP: open the theme cart drawer.
      if (typeof window.showCartLively === "function") {
        window.showCartLively();
        return;
      }
      if (window.KiroQuadCartV6?.render) {
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 12e3);
        try {
          const [a, b] = await Promise.all([fetch(routes.local(cfg.root + "cart.js"), { credentials: "same-origin", cache: "no-store", signal: controller.signal }), fetch(routes.local(cfg.root + "?sections=cart-rendering"), { credentials: "same-origin", cache: "no-store", signal: controller.signal })]);
          if (!a.ok || !b.ok) throw new Error("Cart render unavailable");
          const [cart, sections] = await Promise.all([a.json(), b.json()]);
          if (!sections["cart-rendering"]) throw new Error("Cart section missing");
          window.KiroQuadCartV6.render(cart, sections);
          return;
        } catch {
        } finally {
          clearTimeout(timer);
        }
      }
      location.assign(cfg.cartUrl);
    }
    function lock() {
      root.querySelectorAll(".add,.compare-add").forEach((b) => b.disabled = adding || uncertain || cartCoordinator.busy || b.dataset.unavailable === "true");
    }
    function update(q) {
      qs("[name=id]").value = q.variant.id;
      const sel = qs("[data-variant]");
      sel.replaceChildren(...q.variants.map((v) => {
        const o = document.createElement("option");
        o.value = v.id;
        o.textContent = v.title + (v.available ? "" : " \u2014 sold out");
        o.selected = v.id === q.variant.id;
        return o;
      }));
      sel.parentElement.hidden = q.variants.length < 2;
      root.querySelectorAll(".add").forEach((b) => {
        b.dataset.unavailable = String(!q.available);
        b.textContent = q.available ? "Add to Bag" : "Sold out";
      });
      const was = qs("[data-kp-was]"), compareAt = q.variant.compareAt;
      if (was) {
        was.hidden = !(compareAt > q.variant.price);
        was.textContent = was.hidden ? "" : q.compareText || new Intl.NumberFormat("en-IN", { style: "currency", currency: q.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(compareAt / 100);
      }
      // V3 "Ingredients and usage" module: after a Quad switch, refresh the same fields kiro-v3-pdp.js refreshes on a shade change,
      // from the V3 product data (kiro-pdp-v3-data). The first render is the V3 Liquid output and is left as it is.
      const v3 = v3Data.get(q.handle);
      if (v3 && v3FieldsFor !== q.handle) {
        v3FieldsFor = q.handle;
        rich(qs("[data-kp-ingredients]"), v3.ingredients);
        rich(qs("[data-kp-directions]"), v3.directions);
        rich(qs("[data-kp-description]"), v3.description);
        const setText = (sel, value, rowSel) => {
          const el = qs(sel);
          if (el) el.textContent = value || "";
          if (rowSel && qs(rowSel)) qs(rowSel).hidden = !value;
        };
        setText("[data-kp-volume]", v3.weight);
        setText("[data-kp-origin]", v3.origin);
        setText("[data-kp-generic]", v3.genericName, "[data-kp-generic-row]");
        setText("[data-kp-type]", v3.productType, "[data-kp-type-row]");
        setText("[data-kp-expiry]", v3.expiry, "[data-kp-expiry-row]");
      }
      qs("[data-weight]").textContent = q.weight ? "(" + q.weight + ")" : "";
      if (qs("#kq6-story-texture")) qs("#kq6-story-texture").hidden = !q.macro;
      // URL shows the product handle only — no ?variant= (also removed when the link arrived with one). Other query params and the hash stay.
      // Native History.prototype.replaceState: GA4 / Meta history hooks don't see it, so a Quad change adds no extra page view.
      const url = routes.product(q.handle);
      History.prototype.replaceState.call(history, null, "", url.pathname + url.search + location.hash);
      lock();
    }
    async function refresh(q) {
      const token = ++seq;
      repository.clear();
      v3repo?.clear();
      const [fresh] = await Promise.all([repository.get(q.handle), loadV3(q.handle)]);
      if (token !== seq) throw new Error("");
      return normalizeFromCanonical(fresh);
    }
    function normalizeFromCanonical(p) {
      return { ...p, key: p.handle, name: p.shade, price: p.variant.price, available: p.variant.available, gallery: p.gallery.map((g) => g.url), galleryEntries: p.gallery };
    }
    async function add(q, quantity) {
      if (adding || uncertain || cartCoordinator.busy) return;
      let release, posted = false;
      try {
        release = cartCoordinator.acquire();
        adding = true;
        lock();
        status("Checking availability\u2026");
        repository.clear();
        const fresh = await repository.get(q.handle, q.variant.id);
        if (!fresh.variant.available) throw new Error("This shade is sold out. Choose another.");
        if (fresh.variant.price !== q.price) {
          Object.assign(q, normalizeFromCanonical(fresh));
          await ui.selectHandle(q.handle);
          throw new Error("The price has changed. Please review it before adding.");
        }
        status("Adding to your bag\u2026");
        posted = true;
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 2e4);
        let response, result2;
        try {
          response = await fetch(routes.local(cfg.cartAdd), { method: "POST", credentials: "same-origin", signal: controller.signal, headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: fresh.variant.id, quantity }] }) });
          result2 = await response.json();
        } finally {
          clearTimeout(timer);
        }
        if (!response.ok) {
          throw new Error(result2.description || "Could not confirm your bag update.");
        }
        status("Added to your bag.");
        host.dispatchEvent(new CustomEvent("kiro:quad:cart-added", { bubbles: true, detail: { productId: q.id, variantId: fresh.variant.id, quantity, cartUrl: cfg.cartUrl } }));
        await openCart();
      } catch (e) {
        if (posted) {
          uncertain = true;
          qs("[data-check-cart]").hidden = false;
          status("We could not confirm the bag update. Check your bag before trying again.");
        } else status(e.message || "Could not check availability. Please try again.");
      } finally {
        adding = false;
        release?.();
        lock();
      }
    }
    ui = mountUI(root, initial, cfg, { update, refresh, add, status });
    // Host for the V3 duo: the same members kiro-product-page-v3 gives it, backed by the selected Quad and the V3 product data.
    Object.defineProperty(host, "current", { configurable: true, get: () => v3Data.get(ui.getCurrent().handle) || canonical(ui.getCurrent()) });
    host.q = (s) => host.querySelector(s);
    host.on = (n, e, f) => n?.addEventListener(e, f, { signal: life.signal });
    host.schedule = () => {
    };
    host.life = life;
    host.index = initial.map((q) => ({ handle: q.handle, label: q.name, color: q.colours[0], families: [] }));
    host.media = (p) => ({ image: p.mediaOverride?.product || p.gallery?.find((i) => i && i.url && !i.video)?.url || p.featuredImage || p.hero, skin: p.gallery?.[2]?.url });
    host.select = (handle) => ui.selectHandle(handle);
    host.routes = v3routes || routes;
    host.config = { ...cfg, cartBehavior: "page" };
    host.repository = v3repo || repository;
    host.fetchProduct = (h, v) => (v3repo || repository).get(h, v);
    host.url = (h, v, view) => (v3routes || routes).product(h, v, view);
    // Same as the V3 PDP: after a duo is added, close the picker and open the cart drawer.
    host.addEventListener("kiro:duo:cart-result", (e) => {
      if (e.detail && e.detail.status !== "error") {
        e.preventDefault();
        const dialog = qs("[data-duo-dialog]");
        if (dialog?.open) dialog.close();
        openCart();
      }
    }, { signal: life.signal });
    if (V3) {
      duo = new V3.Duo(host);
      duo.connect();
    }
    qs("[data-variant]").addEventListener("change", async (e) => {
      const token = ++variantSeq, q = ui.getCurrent();
      try {
        repository.clear();
        v3repo?.clear();
        const [p] = await Promise.all([repository.get(q.handle, Number(e.target.value)), loadV3(q.handle, Number(e.target.value))]);
        if (token !== variantSeq || q !== ui.getCurrent()) return;
        ui.apply(normalizeFromCanonical(p));
      } catch (err) {
        status(err.message);
      }
    }, { signal: life.signal });
    document.addEventListener("kiro:cart:busy", lock, { signal: life.signal });
    Promise.allSettled(handles.filter((h) => !initial.some((q) => q.handle === h)).map((h) => repository.get(h))).then((results) => {
      if (life.signal.aborted) return;
      for (const r of results) if (r.status === "fulfilled") ui.addProduct(normalizeFromCanonical(r.value));
      host.index = initial.map((q) => ({ handle: q.handle, label: q.name, color: q.colours[0], families: [] }));
    });
    const result = { dispose() {
      life.abort();
      headerObserver?.disconnect();
      ui.dispose();
      duo?.dispose();
      repository.dispose();
      v3repo?.dispose();
      instances.delete(root);
    } };
    instances.set(root, result);
    return result;
  }
  function boot(parent = document) {
    parent.querySelectorAll("[data-kq6]").forEach((root) => {
      try {
        mount(root);
      } catch (e) {
        console.error("Kiro Quad initialization:", e);
        const status = root.querySelector("[data-purchase-status]");
        if (status) status.textContent = "Interactive features could not load. You can still add this product using the form.";
      }
    });
  }
  if (!window.__kiroQuadV6) {
    window.__kiroQuadV6 = true;
    boot();
    document.addEventListener("shopify:section:load", (e) => boot(e.target));
    document.addEventListener("shopify:section:unload", (e) => {
      for (const [root, instance] of instances) if (e.target.contains(root)) instance.dispose();
    });
  }
})();
